/* eslint-disable no-unused-vars */
import {
  GET_MAIN_BUNNER,
  GET_MAIN_CATEGORIES,
  GET_ONE_PRODUCT,
  GET_CATEGORIES,
  GET_CATEGORY,
  GET_ALL_PRODUCTS,
  GET_ADD_TO_CART,
  GET_ORDER_CART,
  GET_SHOP_ORDER_NUMBER,
  GET_ADD_COUNTER_CART,
  GET_MINUS_COUNTER_CART,
  GET_DELETE_CART,
  GET_CHANGE_PRODUCT_QUANTITY,
  GET_SHOP_PRODUCTS_SEARCH,
  SET_ORDER_BRANCH_SAVE,
  GET_COME_TO_PAY,
  GET_ORDERS,
  GET_FAVORITES,
  SET_FAVORITE,
  GET_ORDER_DETAILS,
  REPEAT_ORDER,
} from "../../resources/js/helpers/requests";

// Every response contains the entire cart, so writes must commit in request order.
let cartQueue = Promise.resolve();
function updateCart({ commit }, request) {
  commit("changeCartPending", 1);
  const update = cartQueue.then(async () => {
    const result = await request();
    if (!result?.data || !Array.isArray(result.data.items)) {
      throw new Error("Invalid cart response");
    }
    commit("setAddProductToCart", result.data);
    return result.data;
  });
  cartQueue = update.catch(() => {});
  return update.finally(() => commit("changeCartPending", -1));
}

async function loadResource({ state, commit }, name, request, mutation) {
  if (state.resources[name].loading) return false;
  commit("setResource", { name, loading: true, error: "" });
  try {
    const result = await request();
    if (!Array.isArray(result.data)) throw new Error("Invalid resource response");
    if (name === "bounds" && (result.max_price == null || !Number.isFinite(Number(result.max_price)) || Number(result.max_price) < 0)) throw new Error("Invalid price bounds");
    commit(mutation, name === "bounds" ? result.max_price : result.data);
    return true;
  } catch (error) {
    commit("setResource", { name, error: "Не вдалося завантажити дані. Перевірте з’єднання та спробуйте ще раз." });
    return false;
  } finally {
    commit("setResource", { name, loading: false });
  }
}

export default {
  state: {
    headerCategodies: [],
    perPage: "",
    openProduct: {},
    allCategodies: [],
    products: [],
    productsTotal: null,
    productsPage: 1,
    productsLastPage: 1,
    productsQuery: {},
    favorites: [],
    favoritesLoaded: false,
    favoritesBusy: false,
    favoritesError: '',
    mainBanners: [],
    isShowProducts: "category",
    perCategoris: [],
    max_price: 0,
    customerCart: {},
    order_id: null,
    searchText: "",
    filterParametrs: {},
    checkedCategory: null,
    orders: [],
    mainLoading: true,
    cartReady: false,
    cartLoading: true,
    cartError: "",
    cartPending: 0,
    productsLoading: false,
    productsError: "",
    productsRequestId: 0,
    oneProductRequestId: 0,
    cartNotice: 0,
    paymentState: "idle",
    paymentOrderId: null,
    savingOrder: false,
    cartUndo: null,
    undoMessage: '',
    repeatPending: false,
    repeatAttempts: {},
    focusedOrder: null,
    selectedOrderId: null,
    resources: {
      home: { loading: false, error: "" },
      banners: { loading: false, error: "" },
      categories: { loading: false, error: "" },
      bounds: { loading: false, error: "" },
      product: { loading: false, error: "" },
      orders: { loading: false, error: "" },
      orderDetails: { loading: false, error: '' },
    },
  },
  mutations: {
    setCartUndo(state, value) { state.cartUndo = value; },
    setUndoMessage(state, value) { state.undoMessage = value; },
    setRepeatPending(state, value) { state.repeatPending = value; },
    setRepeatAttempt(state, { id, key }) {
      const attempts = { ...state.repeatAttempts };
      if (key) attempts[id] = key; else delete attempts[id];
      state.repeatAttempts = attempts;
    },
    setFocusedOrder(state, value) { state.focusedOrder = value; },
    setSelectedOrderId(state, value) { state.selectedOrderId = value; },
    setFavoriteState(state, values) { Object.assign(state, values); },
    setProductsMeta(state, { total, page = 1, lastPage = 1, query = {} }) {
      state.productsTotal = total; state.productsPage = page; state.productsLastPage = lastPage; state.productsQuery = query;
    },
    setResource(state, { name, ...values }) { Object.assign(state.resources[name], values); },
    showCartNotice(state) { state.cartNotice += 1; },
    hideCartNotice(state) { state.cartNotice = 0; },
    setSavingOrder(state, value) { state.savingOrder = value; },
    setPaymentState(state, { id, status }) { state.paymentOrderId = id; state.paymentState = status; },
    startOneProductRequest(state) { state.oneProductRequestId += 1; },
    setProductData(state, product) { state.openProduct = product; },
    setCartReady(state, ready) { state.cartReady = ready; },
    setCartLoading(state, loading) { state.cartLoading = loading; },
    setCartError(state, error) { state.cartError = error; },
    changeCartPending(state, amount) { state.cartPending += amount; },
    startProductsRequest(state) {
      state.productsRequestId += 1;
      state.productsLoading = true;
      state.productsError = "";
    },
    finishProductsRequest(state) { state.productsLoading = false; },
    cancelProductsRequest(state) {
      state.productsRequestId += 1;
      state.productsLoading = false;
      state.productsError = "";
    },
    setProductsError(state, error) { state.productsError = error; },
    setMainLoading(state, value) {
      state.mainLoading = value;
    },
    updateMainCategories(state, category) {
      state.headerCategodies = category;
    },
    updateBanners(state, banners) {
      state.mainBanners = banners;
    },
    addPerPage(state, page) {
      state.perPage = page;
    },
    setIsOpenProductInfo(state, product) {
      state.openProduct = product;
      state.oneProductRequestId += 1;
      state.resources.product.loading = false;
      state.resources.product.error = "";
    },
    getAllCategories(state, categories) {
      state.allCategodies = categories;
    },
    setIsShowProducts(state, value) {
      state.isShowProducts = value;
    },
    setAddPerCategory(state, category) {
      state.perCategoris = category;
    },
    setAddProducts(state, products) {
      state.products = products;
    },
    setAddMaxPrice(state, price) {
      state.max_price = price;
    },
    setAddProductToCart(state, product) {
      state.customerCart = product;
    },
    setOrders(state, orders) {
      state.orders = orders;
    },
    setOrderId(state, id) {
      state.order_id = id;
    },
    setChangeSearchText(state, text) {
      state.searchText = text;
    },
    setFilterParametrs(state, data) {
      state.filterParametrs = data;
    },
    deleteFilterCategoryParametr(state) {
      const { category_ids, ...filters } = state.filterParametrs;
      state.filterParametrs = filters;
    },
    setFilterPriceParametrs(state, data) {
      state.filterParametrs = {
        ...state.filterParametrs,
        price_from: data.price_from,
        price_to: data.price_to,
      };
    },
    deleteFilterParametr(state) {
      state.filterParametrs = {};
    },
    setCheckedCategory(state, data) {
      state.checkedCategory = data;
    },
  },
  actions: {
    async loadHome({ dispatch }) {
      return Promise.all([dispatch("getMainCategories"), dispatch("getMainBunner"), dispatch("allCategories")]);
    },
    getMainBunner(context) {
      return loadResource(context, "banners", GET_MAIN_BUNNER, "updateBanners");
    },
    async getMainCategories(context) {
      context.commit("setMainLoading", true);
      try {
        return await loadResource(context, "home", GET_MAIN_CATEGORIES, "updateMainCategories");
      } finally {
        context.commit("setMainLoading", false);
      }
    },
    async getOneProduct({ commit, state }, id) {
      commit("startOneProductRequest");
      const requestId = state.oneProductRequestId;
      commit("setResource", { name: "product", loading: true, error: "" });
      try {
        const result = await GET_ONE_PRODUCT(id);
        if (!result.data?.id) throw new Error("Invalid product response");
        if (requestId === state.oneProductRequestId) commit("setProductData", result.data);
      } catch (error) {
        if (requestId === state.oneProductRequestId) commit("setResource", { name: "product", error: "Не вдалося завантажити товар." });
      } finally {
        if (requestId === state.oneProductRequestId) commit("setResource", { name: "product", loading: false });
      }
    },
    allCategories(context) {
      return loadResource(context, "categories", GET_CATEGORIES, "getAllCategories");
    },
    async getProductsReq({ commit, state, dispatch }, id) {
      commit("startProductsRequest");
      const requestId = state.productsRequestId;
      try {
        let result = await GET_CATEGORY(id);
        if (requestId !== state.productsRequestId) return;
        if (result.data?.children?.length) {
          commit("setIsShowProducts", "preCategory");
          commit("setAddPerCategory", result.data);
        } else {
          commit('setChangeSearchText', '');
          commit('setFilterParametrs', { category_ids: [id] });
          return await dispatch('searchedProducts', { category_ids: [id] });
        }
      } catch (error) {
        if (requestId === state.productsRequestId) commit("setProductsError", "Не вдалося завантажити товари. Спробуйте ще раз.");
      } finally {
        if (requestId === state.productsRequestId) commit("finishProductsRequest");
      }
    },
    getAllProducts(context) {
      return loadResource(context, "bounds", GET_ALL_PRODUCTS, "setAddMaxPrice");
    },
    async addProductToCart(context, body) {
      const cart = await updateCart(context, async () => {
        const result = await GET_ADD_TO_CART(body);
        return JSON.parse(body).quantity > 1 ? GET_CHANGE_PRODUCT_QUANTITY(body) : result;
      });
      context.commit("showCartNotice");
      return cart;
    },
    async getCartProducts({ commit }, id) {
      commit("setCartReady", false);
      commit("setCartLoading", true);
      commit("setCartError", "");
      try {
        if (!id) throw new Error("Customer ID is missing");
        let order_id = await GET_SHOP_ORDER_NUMBER(id);
        if (!order_id.data?.id) throw new Error("Order ID is missing");
        commit("setOrderId", order_id.data);
        let result = await GET_ORDER_CART(order_id.data.id);
        if (!Array.isArray(result.data?.items)) throw new Error("Invalid cart response");
        commit("setAddProductToCart", result.data);
        commit("setCartReady", true);
      } catch (error) {
        commit("setCartError", "Не вдалося завантажити кошик. Відкрийте магазин із бота або спробуйте ще раз.");
      } finally {
        commit("setCartLoading", false);
      }
    },
    async getCart(context) {
      if (!context.state.order_id?.id) return;
      try {
        await updateCart(context, () => GET_ORDER_CART(context.state.order_id.id));
        context.commit("setCartError", "");
      } catch (error) {
        context.commit("setCartError", "Не вдалося оновити кошик. Спробуйте ще раз.");
      }
    },
    getOrders(context) {
      return loadResource(context, "orders", GET_ORDERS, "setOrders");
    },
    async getOneMoreProduct(context, data) {
      return updateCart(context, () => GET_ADD_COUNTER_CART(data));
    },
    async getMinusProduct(context, data) {
      return updateCart(context, () => GET_MINUS_COUNTER_CART(data));
    },
    async deleteProductFromCart(context, data) {
      const body = JSON.parse(data);
      const item = context.state.customerCart.items?.find(item => String(item.product_id) === String(body.product_id));
      const result = await updateCart(context, () => GET_DELETE_CART(data));
      if (item) {
        context.commit('setCartUndo', { item: { ...item }, orderId: body.order_id, expiresAt: Date.now() + 8000 });
        context.commit('setUndoMessage', '');
      }
      return result;
    },
    async undoCartRemoval(context) {
      const undo = context.state.cartUndo;
      if (!undo || undo.expiresAt < Date.now() || context.state.cartPending) return false;
      context.commit('setUndoMessage', '');
      try { await updateCart(context, async () => {
        if (String(context.state.order_id?.id) !== String(undo.orderId)) throw new Error('Кошик змінився. Оновіть сторінку.');
        const result = await GET_ONE_PRODUCT(undo.item.product_id);
        const fresh = await GET_ORDER_CART(undo.orderId);
        context.commit('setAddProductToCart', fresh.data);
        const product = result.data;
        const stock = product?.available === false ? 0 : Number(product?.qty) || 0;
        if (stock < 1) throw new Error('Товар зараз недоступний.');
        const existing = fresh.data.items.find(item => String(item.product_id) === String(undo.item.product_id));
        const quantity = Math.min(stock, (Number(existing?.qty_item) || 0) + Number(undo.item.qty_item));
        const body = JSON.stringify({ order_id: undo.orderId, product_id: undo.item.product_id, quantity });
        if (!existing) {
          const added = await GET_ADD_TO_CART(body);
          context.commit('setAddProductToCart', added.data);
          if (quantity === 1) return added;
        }
        return GET_CHANGE_PRODUCT_QUANTITY(body);
      });
      } catch (error) {
        context.commit('setCartUndo', null);
        await context.dispatch('getCart');
        throw error;
      }
      context.commit('setCartUndo', null);
      context.commit('setUndoMessage', 'Товар повернуто. Кількість і ціна перевірені за поточним каталогом.');
      return true;
    },
    async loadOrderDetails({ commit, state }, id) {
      commit('setSelectedOrderId', id);
      commit('setFocusedOrder', null);
      commit('setResource', { name: 'orderDetails', loading: true, error: '' });
      try {
        const result = await GET_ORDER_DETAILS(id);
        if (!result.data?.id) throw new Error('Invalid order');
        if (state.selectedOrderId === id) commit('setFocusedOrder', result.data);
      } catch (error) {
        if (state.selectedOrderId === id) commit('setResource', { name: 'orderDetails', error: error.status === 404 ? 'Замовлення недоступне або належить іншому покупцю.' : 'Не вдалося відкрити замовлення. Відкрийте магазин заново з бота або спробуйте ще раз.' });
      } finally { if (state.selectedOrderId === id) commit('setResource', { name: 'orderDetails', loading: false }); }
    },
    async repeatOrder(context, id) {
      if (context.state.repeatPending || context.state.cartPending) return false;
      context.commit('setRepeatPending', true);
      const requestKey = context.state.repeatAttempts[id] || `web:${Date.now()}-${Math.random().toString(36).slice(2)}`;
      context.commit('setRepeatAttempt', { id, key: requestKey });
      context.commit('setCartUndo', null);
      try {
        let orderId;
        const cart = await updateCart(context, async () => {
          const result = await REPEAT_ORDER(id, requestKey);
          orderId = result.order_id;
          return result;
        });
        if (orderId) context.commit('setOrderId', { ...context.state.order_id, id: orderId });
        context.commit('setCartReady', true);
        context.commit('setRepeatAttempt', { id, key: null });
        return cart;
      } finally { context.commit('setRepeatPending', false); }
    },
    setCartQuantity(context, data) {
      return updateCart(context, () => GET_CHANGE_PRODUCT_QUANTITY(data));
    },
    async changeCatalogCartQuantity(context, { product, direction }) {
      const { state } = context;
      if (!state.cartReady || state.cartPending) return;
      const wasInCart = (state.customerCart.items || []).some(item => String(item.product_id) === String(product.id) && !item.no_product);
      const cart = await updateCart(context, () => {
        const item = (state.customerCart.items || []).find(item => String(item.product_id) === String(product.id) && !item.no_product);
        const quantity = Number(item?.qty_item) || 0;
        const stock = Number(item?.qty_product ?? product.qty) || 0;
        const body = JSON.stringify({ order_id: state.order_id.id, product_id: product.id });
        if (direction === 1) {
          if (quantity >= stock) throw new Error("Not enough stock");
          return quantity ? GET_ADD_COUNTER_CART(body) : GET_ADD_TO_CART(body);
        }
        if (!quantity) throw new Error("Product is not in cart");
        return quantity === 1 ? GET_DELETE_CART(body) : GET_MINUS_COUNTER_CART(body);
      });
      if (direction === 1 && !wasInCart) context.commit("showCartNotice");
      return cart;
    },
    async addProductFromDetails(context, { product, quantity }) {
      if (!context.state.cartReady || context.state.cartPending) return false;
      const cart = await updateCart(context, async () => {
        const existing = context.state.customerCart.items.find(item => String(item.product_id) === String(product.id) && !item.no_product);
        const target = (Number(existing?.qty_item) || 0) + Number(quantity);
        if (!Number.isInteger(target) || quantity < 1 || target > Number(existing?.qty_product ?? product.qty)) throw new Error("Not enough stock");
        const body = JSON.stringify({ order_id: context.state.order_id.id, product_id: product.id, quantity: target });
        if (!existing) {
          const added = await GET_ADD_TO_CART(body);
          // Keep a successful first step if a later quantity request fails.
          context.commit("setAddProductToCart", added.data);
          if (target === 1) return added;
        }
        return GET_CHANGE_PRODUCT_QUANTITY(body);
      });
      context.commit("showCartNotice");
      return cart;
    },
    async searchedProducts({ commit, state }, data = {}) {
      commit("startProductsRequest");
      const requestId = state.productsRequestId;
      commit("setIsShowProducts", "products");
      try {
        let result = await GET_SHOP_PRODUCTS_SEARCH(data);
        if (!Array.isArray(result.data)) throw new Error("Invalid search response");
        if (requestId === state.productsRequestId) {
          commit("setAddProducts", result.data);
          commit('setProductsMeta', { total: Number.isInteger(result.meta?.total) ? result.meta.total : null, page: result.meta?.current_page || 1, lastPage: result.meta?.last_page || 1, query: { ...data } });
        }
      } catch (error) {
        if (requestId === state.productsRequestId) commit("setProductsError", "Не вдалося завантажити товари. Спробуйте ще раз.");
      } finally {
        if (requestId === state.productsRequestId) commit("finishProductsRequest");
      }
    },
    async loadFavorites({ state, commit }) {
      if (state.favoritesBusy) return false;
      commit('setFavoriteState', { favoritesBusy: true, favoritesError: '' });
      try {
        const result = await GET_FAVORITES();
        if (!Array.isArray(result.data)) throw new Error('Invalid favorites response');
        commit('setFavoriteState', { favorites: result.data, favoritesLoaded: true });
        return true;
      } catch (error) {
        commit('setFavoriteState', { favoritesError: error.status === 401 || error.status === 403 ? 'Відкрийте магазин заново з Telegram-бота.' : 'Не вдалося завантажити обране. Спробуйте ще раз.' });
        return false;
      } finally { commit('setFavoriteState', { favoritesBusy: false }); }
    },
    async toggleFavorite({ state, commit, dispatch }, product) {
      if (state.favoritesBusy) return;
      if (!state.favoritesLoaded && !await dispatch('loadFavorites')) throw new Error('Favorites not loaded');
      if (state.favoritesBusy) return;
      const saved = state.favorites.some(item => String(item.id) === String(product.id));
      commit('setFavoriteState', { favoritesBusy: true });
      try {
        const result = await SET_FAVORITE(product.id, !saved);
        if (result.status !== true) throw new Error('Favorite was not saved');
        commit('setFavoriteState', { favorites: saved ? state.favorites.filter(item => String(item.id) !== String(product.id)) : [...state.favorites, product] });
      } finally { commit('setFavoriteState', { favoritesBusy: false }); }
    },
    async setSaveOrder({ commit, state }, data) {
      if (state.savingOrder) return false;
      commit("setSavingOrder", true);
      try {
        const result = await SET_ORDER_BRANCH_SAVE(data);
        if (result.status !== true) throw new Error("Delivery was not saved");
        return result;
      } finally {
        commit("setSavingOrder", false);
      }
    },
    async setReturnToBot({ commit, state }, id) {
      if (state.paymentOrderId === id && state.paymentState !== "idle") {
        if (state.paymentState === "complete") return { status: true };
        throw new Error("Перевірте повідомлення про оплату в боті.");
      }
      commit("setPaymentState", { id, status: "pending" });
      try {
        const result = await GET_COME_TO_PAY(id);
        if (result.status !== true) throw new Error("Payment was not confirmed");
        commit("setPaymentState", { id, status: "complete" });
        return result;
      } catch (error) {
        // An error can arrive after the bot message was sent. Do not send it twice.
        commit("setPaymentState", { id, status: "uncertain" });
        throw error;
      }
    },
  },
  getters: {
    cartUndo: state => state.cartUndo,
    undoMessage: state => state.undoMessage,
    repeatPending: state => state.repeatPending,
    focusedOrder: state => state.focusedOrder,
    selectedOrderId: state => state.selectedOrderId,
    favorites: state => state.favorites,
    favoritesBusy: state => state.favoritesBusy,
    favoritesError: state => state.favoritesError,
    productsTotal: state => state.productsTotal,
    productsPage: state => state.productsPage,
    productsLastPage: state => state.productsLastPage,
    productsQuery: state => state.productsQuery,
    resources: state => state.resources,
    cartNotice: state => state.cartNotice,
    paymentState: state => state.paymentState,
    cartReady: state => state.cartReady,
    cartLoading: state => state.cartLoading,
    cartError: state => state.cartError,
    cartUpdating: state => state.cartPending > 0,
    productsLoading: state => state.productsLoading,
    productsError: state => state.productsError,
    perPageName: (state) => {
      return state.perPage;
    },
    allHeaderCategories: (state) => {
      return state.headerCategodies;
    },
    allMainBunners: (state) => {
      return state.mainBanners;
    },
    openedProduct: (state) => {
      return state.openProduct;
    },
    allCategories: (state) => {
      return state.allCategodies;
    },
    isShowProducts: (state) => {
      return state.isShowProducts;
    },
    preCategories: (state) => {
      return state.perCategoris;
    },
    getProducts: (state) => {
      return state.products;
    },
    getMaxPrice: (state) => {
      return state.max_price;
    },
    getCustomerCart: (state) => {
      return state.customerCart;
    },
    getOrderId: (state) => {
      return state.order_id;
    },
    getSearchText: (state) => {
      return state.searchText;
    },
    getFilterParametrs: (state) => {
      return state.filterParametrs;
    },
    getCheckedCategory: (state) => {
      return state.checkedCategory;
    },
    getOrders: (state) => {
      return state.orders;
    },
    isMainLoading: (state) => {
      return state.mainLoading || state.resources.home.loading;
    },
  },
};
